export const formatDateTime = (iso: string): string =>
  new Date(iso).toLocaleString();

export const formatDate = (iso: string): string =>
  new Date(iso).toLocaleDateString();

export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

const RELATIVE = new Intl.RelativeTimeFormat([], { numeric: "auto" });

const RELATIVE_STEPS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["second", 60],
  ["minute", 60],
  ["hour", 24],
  ["day", 7],
  ["week", 4.35],
  ["month", 12],
];

export const formatRelativeTimeMs = (timestamp: number): string => {
  let delta = (timestamp - Date.now()) / 1000;
  for (const [unit, span] of RELATIVE_STEPS) {
    if (Math.abs(delta) < span) return RELATIVE.format(Math.round(delta), unit);
    delta /= span;
  }
  return RELATIVE.format(Math.round(delta), "year");
};

export const formatMonthDay = (iso: string): string =>
  new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" });

export const formatCountdown = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
